export default __webpack_public_path__ + "static/media/asc.874d153e.svg";